<template>
  <div class="business">
    <div class="business-card">
      <div class="title">
        <h2>管理业务板块</h2>
        <span>你可以在这里创建业务板块。</span>
      </div>
      <div class="content">
        <el-table :data="businessData" style="width: 100%" :show-header="false" :row-class-name="customClass">
          <el-table-column prop="name">
            <template slot-scope="scope">
              <div v-if="!scope.row.isEdit && $permission('项目管理-新增业务板块')" @click="edit(scope.row)" style="height: 28px">
                {{scope.row.name}}
              </div>
              <div v-else>
                <div class="edit-box">
                  <el-input ref="input" placeholder="请输入业务模块名称" size="mini" v-model="scope.row.name"></el-input>
                  <el-button type="primary" size="mini" @click="submitName(scope.row)">确认</el-button>
                  <el-button size="mini" @click="cancelName(scope.row)">取消</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="icon">
            <template slot-scope="scope">
              <IconPanel :iconInfo="scope.row" @changeIcon="changeIcon" v-if="$permission('项目管理-更新业务板块')">
                <div class="icon-box">
                  <i class="iconfont" :class="scope.row.icon" :style="{color: scope.row.icon_color}"></i>
                </div>
              </IconPanel>
              <div class="icon-box" v-else>
                <i class="iconfont" :class="scope.row.icon" :style="{color: scope.row.icon_color}"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <div class="hover-icon-box">
                <i v-permission="'项目管理-删除业务板块'" class="el-icon-delete" @click="del(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="other">
          <!-- <div class="add-business" @click="addBusiness"><i class="icon iconfont iconicon_enlarge"></i>添加业务模块</div> -->
          <wf-button v-permission="'项目管理-新增业务板块'" class="add-business" @click="addBusiness" icon="icon iconfont iconicon_enlarge" plain>添加业务模块</wf-button>
          <!-- <div v-else class="submit add-business" @click="addSumit">保存设置</div> -->
        </div>
      </div>
    </div>
    <div class="business-card mt16">
      <div class="title">
        <h2>调整业务板块优先级</h2>
        <span>你可以在这里对不同团队的业务板块进行调序。</span>
      </div>
      <div class="content">
        <div v-for="item in departmentProjectFolderList" :key="item.department_category_id">
          <div class="depart-title">
            <span class="line" :style="{'background':Color()}"></span>
            {{item.name}}
          </div>
          <vuedraggable element="ul" v-bind="dragOptionsList(item.department_category_id)" :list="item.projectList" @end="departFolderOrderby">
            <li class="folder-item" :depId="innerItem.department_category_id" v-for="innerItem in item.projectList" :key="innerItem.project_list_id">
              <div class="folder-name">
                <div class="icons-item">
                  <i class="iconfont" :class="innerItem.icon"></i>
                </div>
                {{innerItem.title}}
              </div>
              <span v-permission="'项目管理-更新业务板块可见性'" class="tip hide" @click="tagertFolder(innerItem)" v-if="innerItem.active">隐藏</span>
              <span v-permission="'项目管理-更新业务板块可见性'" class="tip show" @click="tagertFolder(innerItem)" v-else>显示</span>
            </li>
          </vuedraggable>
        </div>
      </div>
    </div>
    <div style="height: 30px;"></div>
  </div>
</template>

<script>
import Api from '@/services/api/systemSetting/systemSetting';
import IconPanel from "./iconPanel"
import vuedraggable from "vuedraggable";
import { mapMutations } from 'vuex';
export default {
  name: "business",
  components: {
    IconPanel,
    vuedraggable
  },
  data() {
    return {
      businessData: [],
      departmentProjectFolderList: [],
      oldName: {},
      viewSumitBtn: false
    }
  },
  created() {
    this.fetchBusinessData();
    this.fetchProjectFolderList();
  },
  methods: {
    Color() {
      this.r = Math.floor(Math.random() * 255);
      this.g = Math.floor(Math.random() * 255);
      this.b = Math.floor(Math.random() * 255);
      return 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',1)';
    },
    fetchBusinessData() {
      // 获取业务板块数据
      Api.getProjectFolderList().then(res => {
        this.businessData = res.List.map((item) => {
          item.id = item.project_list_id
          item.name = item.title
          item.isEdit = false
          return item;
        })
      })
    },
    fetchProjectFolderList() {
      Api.getDepartmentProjectFolderList().then(res => {
        this.departmentProjectFolderList = res.List;
        this.departmentProjectFolderList.map(item => {
          item.projectList = this.groupData(item.projectList)
        })
      })
    },
    groupData(data) {
      let arr_1 = [];
      let arr_0 = [];
      data.forEach((item) => {
        if (item.active) {
          arr_1.push(item)
        } else {
          arr_0.push(item)
        }
      })
      return [...arr_1, ...arr_0];
    },
    customClass(Obj) {
      return Obj.row.isAdd ? "add-row" : "my-row";
    },
    edit(rowData) {
      rowData.isEdit = true;
      // 需要记录一下数据
      this.oldName[rowData.icon] = rowData.name
      this.$nextTick(() => {
        this.$refs['input'].focus();
      })
    },
    submitName(rowData) {
      rowData.isEdit = false;
      if (rowData.isAdd) {
        Api.addProjectFolder({
          'title': rowData.name,
          'icon': rowData.icon,
          'icon_color': rowData.icon_color  //必填
        }).then(res => {
          this.success();
        }).catch(err => {
          this.cancelName(rowData)
        })
      } else {
        Api.updateProjectFolder({
          'project_list_id': rowData.id,
          'title': rowData.name
        }).then(res => {
          this.success();
        })
      }
    },
    cancelName(rowData) {
      if (rowData.isAdd) {
        this.businessData.pop();
      } else {
        rowData.isEdit = false;
        rowData.name = this.oldName[rowData.icon]
      }
    },
    addBusiness() {
      this.businessData.push({
        name: "",
        icon: 'iconwaimai',
        icon_color: '#E25359',
        isEdit: true,
        isAdd: true
      })
      this.viewSumitBtn = true;
    },
    async del(rowData) {
      await this.$wfAlert('warning', `确认删除此业务？`)
      // 删除业务线
      await Api.deleteProjectFolder({
        project_list_id: rowData.project_list_id
      })
      this.success();
    },
    changeIcon(data) {
      Api.updateProjectFolder(data).then(res => {
        this.success();
      })
    },
    success() {
      this.fetchBusinessData();
      this.fetchProjectFolderList();
    },
    tagertFolder(itemData) {
      Api.updateDepartmentProjectFolder({
        'project_list_id': itemData.project_list_id,  //必填
        'department_category_id': itemData.department_category_id,  //必填
        'active': !itemData.active - 0  //非必填
      }).then(res => {
        this.success();
      })
    },
    departFolderOrderby(event) {
      let depId = event.clone.getAttribute("depId");
      let orderbyArr = [];
      this.departmentProjectFolderList.forEach((item) => {
        if (item.department_category_id == depId) {
          orderbyArr = item.projectList
        }
      })
      let temp = [];
      let len = orderbyArr.length;
      for (let i = 0, j = len; i < len; i++, j--) {
        temp.push({
          project_list_id: orderbyArr[i].project_list_id,
          orderby: j
        })
      }
      Api.updateDepartmentProjectFolderOrderby({
        department_category_id: depId,
        list: temp
      }).then(res => {
      })
    },
    dragOptionsList(department_category_id) {
      return {
        animation: 200,
        group: 'gt-' + department_category_id,
        disabled: !this.$permission('项目管理-更新业务板块排序')
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.business {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  padding: 10px;
}
.mt16 {
  margin-top: 16px;
}
.business-card {
  background: #f8f9fb;
  border: 1px solid #e7e8ed;
  border-radius: 8px;
  .title {
    display: flex;
    align-items: baseline;
    height: 50px;
    line-height: 50px;
    color: initial;
    padding: 0 10px;
    border-bottom: 1px solid #e7e8ed;
    h2 {
      font-size: 16px;
      font-weight: 400;
      margin-right: 20px;
    }
    span {
      opacity: 0.4;
      font-size: 12px;
      color: initial;
    }
  }
}
.add-business {
  cursor: pointer;
  width: 240px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #2682ff;
  background: #cee3ff;
  border-radius: 4px;
}
.add-business > .iconicon_enlarge {
  color: #2682ff;
}
.submit {
  background: #509aff;
  color: #fff;
}
.edit-box {
  display: flex;
  justify-content: space-between;
}
.edit-box .el-input {
  margin-right: 10px;
}
.other {
  padding: 26px 16px;
}
.icon-box {
  cursor: pointer;
  width: 28px;
  height: 28px;
  border: 1px solid rgba(32, 32, 32, 0.08);
  text-align: center;
  line-height: 28px;
  background: #ffffff;
  border-radius: 4px;
}
.icon-box > i {
  font-size: 16px;
}
.hover-icon-box {
  width: 100%;
  height: 100%;
  display: flex;
}
.my-row .el-icon-delete {
  display: none;
}
.my-row:hover .el-icon-delete {
  display: block;
  font-size: 16px;
  color: #e25359;
  cursor: pointer;
}
.add-row .el-icon-delete,
.add-row .icon-box {
  display: none;
}
.depart-title {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #e7e8ed;
  padding: 0 16px;
  display: flex;
  align-items: center;
  .line {
    width: 4px;
    height: 14px;
    border-radius: 4px;
    display: block;
    margin-right: 8px;
  }
}

.folder-item {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 36px;
  border-bottom: 1px solid #e7e8ed;
  display: flex;
  &:hover {
    background: rgba(80, 154, 255, 0.08);
  }
  .folder-name {
    width: 470px;
    border-right: 1px solid #e7e8ed;
    display: flex;
    align-items: center;
  }
  .icons-item {
    cursor: pointer;
    width: 24px;
    height: 24px;
    border: 1px solid rgba(32, 32, 32, 0.08);
    text-align: center;
    line-height: 24px;
    background: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    margin-right: 8px;
    .iconfont {
      color: rgba(25, 24, 67, 0.6);
    }
  }
  .tip {
    cursor: pointer;
    padding-left: 20px;
    font-size: 14px;
  }
  .tip.hide {
    color: #ffa350;
  }
  .tip.show {
    color: rgba(80, 154, 255, 1);
  }
}
</style>
